export const COLORS = {
  darkBlueGray: "#001030",
  lightOcean: "#3ED4D4",
  mediumBlue: "#2962FF",
  darkBlue: "#1B1D65",
};
